import Empresa from "./components/Empresa";
import Navbar from "./components/Navbar";
import Produtos from "./components/Produtos";
import Servicos from "./components/Servicos";
import Contatos from "./components/Contatos";
import "./App.css";
import Footer from "./components/Footer";
function App() {
  return (
    <>
      <Navbar />
      <Empresa />
      <Produtos />
      <Servicos />
      <Contatos />
      <Footer />
    </>
  );
}

export default App;
